export class DocumentAuditEventsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getDocumentAuditEvents({ documentId }) {
    return this.#http.get(`/api/document-audit-events/documents/${documentId}`);
  }
}
